import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const WelcomeModal = ({ isOpen, onClose }) => {
  const [mounted, setMounted] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setMounted(true);
    if (isOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!mounted || !isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9990] flex items-center justify-center p-4 bg-black/50">
      <div className="relative w-full max-w-[1200px] max-h-max bg-white rounded-[35px] shadow-lg md:p-8 p-4 m-4 mt-10 lg:mt-4 animate-in fade-in duration-300">
        {/* Close Button */}
        <div className="absolute top-4 right-4 md:top-6 md:right-6">
          {/* <button
            onClick={onClose}
            className="flex py-1 px-3 items-center text-[14px] md:text-[16px] rounded-full bg-[#f0e6ff] text-[#805aed] hover:bg-[#dcc6ff] transition-colors"
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#dcc6ff'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f0e6ff'}
          >
            Close <span className="text-[20px] md:text-[24px] ml-1">&times;</span>
          </button> */}
        </div>

        {/* Title */}
        <h2 className="text-center text-[24px] sm:text-[30px] md:text-[40px] font-bold mt-4 md:mt-8 mb-8 md:mb-16">
          <span className="text-[#444c5e]">
            {" "}
            {t("welcomeModal.only_three")}
          </span>
          &nbsp;
          <span className="text-[#805aed]">{t("welcomeModal.simple")} </span>
          <span className="text-[#444c5e]"> {t("welcomeModal.steps")}</span>
        </h2>

        {/* Steps Container */}
        <div className="flex flex-col md:flex-shrink lg:flex-row justify-center items-center gap-4 md:gap-10 mb-8 md:mb-16 px-2 md:px-16">
          {/* Step 1 */}
          <div className="flex flex-col items-center w-full md:w-auto md:min-w-[260px] relative">
            <div className="relative flex justify-center w-full">
              <div className="w-[60px] h-[60px] md:w-[83px] md:h-[83px] bg-[#805aed] rounded-full flex items-center justify-center">
                <span className="text-white text-[24px] md:text-[35px] font-bold">
                  {t("welcomeModal.step_one")}
                </span>
              </div>
              {/* Desktop connector line */}
              {/* <div className="hidden md:block absolute top-1/2 left-[calc(50%+41.5px)] right-[-50%] border-t border-[#7f7f7f]" /> */}
            </div>
            <h3 className="text-[#444c5e] text-[16px] md:text-[26px] font-bold mt-3 md:mt-6 text-center">
              {t("welcomeModal.take_the_test")}
            </h3>
          </div>

          {/* Step 2 */}
          <div className="flex flex-col items-center w-full md:w-auto md:min-w-[260px] relative">
            <div className="relative flex justify-center w-full">
              <div className="w-[60px] h-[60px] md:w-[83px] md:h-[83px] bg-[#805aed] rounded-full flex items-center justify-center">
                <span className="text-white text-[24px] md:text-[35px] font-bold">
                  {t("welcomeModal.step_two")}
                </span>
              </div>
              {/* Desktop connector line */}
              {/* <div className="hidden md:block absolute top-1/2 left-[calc(50%+41.5px)] right-[-50%] border-t border-[#7f7f7f]" /> */}
            </div>
            <h3 className="text-[#444c5e] text-[16px] md:text-[26px] font-bold mt-3 md:mt-6 text-center">
              {t("welcomeModal.get_your_results")}
            </h3>
          </div>

          {/* Step 3 */}
          <div className="flex flex-col items-center w-full md:w-auto md:min-w-[260px] relative">
            <div className="w-[60px] h-[60px] md:w-[83px] md:h-[83px] bg-[#805aed] rounded-full flex items-center justify-center">
              <span className="text-white text-[24px] md:text-[35px] font-bold">
                {t("welcomeModal.step_three")}
              </span>
            </div>
            <h3 className="text-[#444c5e] text-[16px] md:text-[26px] font-bold mt-3 md:mt-6 text-center">
              {t("welcomeModal.explore_and_grow")}
            </h3>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mb-2 md:mb-0">
          <button
            id="welcome-modal-get-started-button"
            onClick={onClose}
            className="bg-[#fe6634] hover:bg-[#e55a2d] text-white font-bold text-[15px] md:text-[17px] rounded-[31.50px] px-8 md:px-12 py-3 md:py-4 transition-colors"
          >
            {t("welcomeModal.let_started")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
